import {
  GET_LIST_ACCOUNT_TRANSACTION,
  GET_LIST_ACCOUNT_TRANSACTION_SUCCESS,
  GET_LIST_ACCOUNT_TRANSACTION_FAIL,
  GET_ACCOUNT_TRANSACTION,
  GET_ACCOUNT_TRANSACTION_SUCCESS,
  GET_ACCOUNT_TRANSACTION_FAIL,
  ADD_ACCOUNT_TRANSACTION,
  ADD_ACCOUNT_TRANSACTION_SUCCESS,
  ADD_ACCOUNT_TRANSACTION_FAIL,
  DELETE_ACCOUNT_TRANSACTION,
  DELETE_ACCOUNT_TRANSACTION_SUCCESS,
  DELETE_ACCOUNT_TRANSACTION_FAIL,
  CLEAR_LIST_ACCOUNT_TRANSACTION,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL,
  EXPORT_EXCEL_ACCOUNT_TRANSACTION,
  EXPORT_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  EXPORT_EXCEL_ACCOUNT_TRANSACTION_FAIL,
  UPDATE_ACCOUNT_TRANSACTION,
  UPDATE_ACCOUNT_TRANSACTION_SUCCESS,
  UPDATE_ACCOUNT_TRANSACTION_FAIL,
  ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION,
  ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL,
  GET_LIST_ACCOUNT_TRANSACTION_DRAFT,
  GET_LIST_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  GET_LIST_ACCOUNT_TRANSACTION_DRAFT_FAIL,
  CLEAR_LIST_ACCOUNT_TRANSACTION_DRAFT,
  UPDATE_ACCOUNT_TRANSACTION_DRAFT,
  UPDATE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  UPDATE_ACCOUNT_TRANSACTION_DRAFT_FAIL,
  DELETE_ACCOUNT_TRANSACTION_DRAFT,
  DELETE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  DELETE_ACCOUNT_TRANSACTION_DRAFT_FAIL,
  UPDATE_ACCOUNT_TRANSACTION_CHECK,
  UPDATE_ACCOUNT_TRANSACTION_CHECK_ALL,
  DELETE_ACCOUNT_TRANSACTION_BULK,
  DELETE_ACCOUNT_TRANSACTION_BULK_SUCCESS,
  DELETE_ACCOUNT_TRANSACTION_BULK_FAIL,
} from "./actionTypes";
  
  export const getListAccountTransaction = filter => ({
    type: GET_LIST_ACCOUNT_TRANSACTION,
    payload: filter
  });
  export const getListAccountTransactionSuccess = accountTransactions => ({
    type: GET_LIST_ACCOUNT_TRANSACTION_SUCCESS,
    payload: accountTransactions,
  });
  export const getListAccountTransactionFail = error => ({
    type: GET_LIST_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });

  export const getAccountTransaction = filter => ({
    type: GET_ACCOUNT_TRANSACTION,
    payload: filter
  });
  export const getAccountTransactionSuccess = data => ({
    type: GET_ACCOUNT_TRANSACTION_SUCCESS,
    payload: data,
  });
  export const getAccountTransactionFail = error => ({
    type: GET_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });
  
  export const addAccountTransaction = (accountTransaction, history) => ({
    type: ADD_ACCOUNT_TRANSACTION,
    payload: { accountTransaction, history },
  });
  export const addAccountTransactionSuccess = () => ({
    type: ADD_ACCOUNT_TRANSACTION_SUCCESS,
  });
  export const addAccountTransactionFail = error => ({
    type: ADD_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });

  export const updateAccountTransaction = (accountTransaction, history) => ({
    type: UPDATE_ACCOUNT_TRANSACTION,
    payload: { accountTransaction, history },
  });
  export const updateAccountTransactionSuccess = () => ({
    type: UPDATE_ACCOUNT_TRANSACTION_SUCCESS,
  });
  export const updateAccountTransactionFail = error => ({
    type: UPDATE_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });
  
  export const deleteAccountTransaction = (accountTransaction, filter) => ({
    type: DELETE_ACCOUNT_TRANSACTION,
    payload: { accountTransaction, filter },
  });
  export const deleteAccountTransactionSuccess = () => ({
    type: DELETE_ACCOUNT_TRANSACTION_SUCCESS,
  });
  export const deleteAccountTransactionFail = error => ({
    type: DELETE_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });

  export const clearListAccountTransaction = () => ({
    type: CLEAR_LIST_ACCOUNT_TRANSACTION,
  });

  export const addAccountTransactionByExcel = (uploadFile, companyId, history) => ({
    type: ADD_BY_EXCEL_ACCOUNT_TRANSACTION,
    payload: { uploadFile, companyId, history },
  });
  export const addAccountTransactionByExcelSuccess = () => ({
    type: ADD_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  });
  export const addAccountTransactionByExcelFail = error => ({
    type: ADD_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });

  export const exportExcelAccountTransaction = filter => ({
    type: EXPORT_EXCEL_ACCOUNT_TRANSACTION,
    payload: { filter },
  });
  export const exportExcelAccountTransactionSuccess = () => ({
    type: EXPORT_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  });
  export const exportExcelAccountTransactionFail = error => ({
    type: EXPORT_EXCEL_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });

  export const addAccountTransactionDraftByExcel = (uploadFile, companyId, history) => ({
    type: ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION,
    payload: { uploadFile, companyId, history },
  });
  export const addAccountTransactionDraftByExcelSuccess = () => ({
    type: ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_SUCCESS,
  });
  export const addAccountTransactionDraftByExcelFail = error => ({
    type: ADD_DRAFT_BY_EXCEL_ACCOUNT_TRANSACTION_FAIL,
    payload: error,
  });

  export const getListAccountTransactionDraft = filter => ({
    type: GET_LIST_ACCOUNT_TRANSACTION_DRAFT,
    payload: filter
  });
  export const getListAccountTransactionDraftSuccess = accountTransactions => ({
    type: GET_LIST_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
    payload: accountTransactions,
  });
  export const getListAccountTransactionDraftFail = error => ({
    type: GET_LIST_ACCOUNT_TRANSACTION_DRAFT_FAIL,
    payload: error,
  });

  export const clearListAccountTransactionDraft = () => ({
    type: CLEAR_LIST_ACCOUNT_TRANSACTION_DRAFT,
  });


  export const updateAccountTransactionDraft = (accountTransactionDrafts, callback) => ({
    type: UPDATE_ACCOUNT_TRANSACTION_DRAFT,
    payload: { accountTransactionDrafts, callback },
  });
  export const updateAccountTransactionDraftSuccess = () => ({
    type: UPDATE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  });
  export const updateAccountTransactionDraftFail = error => ({
    type: UPDATE_ACCOUNT_TRANSACTION_DRAFT_FAIL,
    payload: error,
  });

  export const deleteAccountTransactionDraft = (accountTransactionDrafts, callback) => ({
    type: DELETE_ACCOUNT_TRANSACTION_DRAFT,
    payload: { accountTransactionDrafts, callback },
  });
  export const deleteAccountTransactionDraftSuccess = () => ({
    type: DELETE_ACCOUNT_TRANSACTION_DRAFT_SUCCESS,
  });
  export const deleteAccountTransactionDraftFail = error => ({
    type: DELETE_ACCOUNT_TRANSACTION_DRAFT_FAIL,
    payload: error,
  });

  export const updateAccountTransactionCheck = (idx) => ({
    type: UPDATE_ACCOUNT_TRANSACTION_CHECK,
    payload: { idx },
  });

  export const updateAccountTransactionCheckAll = (data) => ({
    type: UPDATE_ACCOUNT_TRANSACTION_CHECK_ALL,
    payload: { data },
  });

  export const deleteAccountTransactionBulk = (data, filter) => ({
    type: DELETE_ACCOUNT_TRANSACTION_BULK,
    payload: { data, filter },
  });
  export const deleteAccountTransactionBulkSuccess = () => ({
    type: DELETE_ACCOUNT_TRANSACTION_BULK_SUCCESS,
  });
  export const deleteAccountTransactionBulkFail = error => ({
    type: DELETE_ACCOUNT_TRANSACTION_BULK_FAIL,
    payload: error,
  });